<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="收支明细"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="toSearch"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <p class="search" @click="showDatePopup">
        <span>{{ selectData }}</span>
        <span class="icon"><van-icon name="play" /></span>
      </p>
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经是全部内容了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <van-row v-if="item.type == 1">
              <van-col span="24" class="title">
                {{ item.goods_name }}
              </van-col>
              <van-col span="24">订单编号：{{ item.ordersn }}</van-col>
              <van-col span="24">完成时间：{{ item.created_at }}</van-col>
              <van-col span="24">
                商品ID：{{ item.goods_id }}
                <span class="commission">
                  <span class="balance">
                    <span>+</span>{{ item.balance }}
                  </span>
                </span>
              </van-col>
            </van-row>
            <van-row v-if="item.type == 3">
              <van-col span="24" class="title">
                {{ item.balance > 0 ? "平台增加" : "平台扣减" }}
              </van-col>
              <van-col span="24">原因：{{ item.reason }}</van-col>
              <van-col span="24">操作时间：{{ item.created_at }}</van-col>
              <van-col span="24">
                操作ID：{{ item.id }}
                <span class="commission">
                  <span class="word">金额：</span>
                  <span class="balance">
                    <span v-show="item.balance > 0">+</span
                    ><span v-show="item.balance < 0">-</span
                    >{{ item.balance > 0 ? item.balance : -item.balance }}
                  </span>
                </span>
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </van-pull-refresh>

      <van-row class="empty" v-if="list.length == 0 && !hasList">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>

      <div class="loading" v-if="list.length <= 0 && hasList">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>

      <van-popup v-model="showdate" position="bottom">
        <van-row class="title">
          <van-col span="12" :class="{ active: selectFirst }">
            <p class="decs">开始日期</p>
            <p>{{ startTime }}</p>
            <span></span>
          </van-col>
          <van-col span="12" :class="{ active: !selectFirst }">
            <p class="decs">结束日期</p>
            <p>{{ endTime }}</p>
            <span></span>
          </van-col>
        </van-row>
        <van-datetime-picker
          :formatter="formatter"
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :item-height="'5.1rem'"
          :visible-item-count="5"
          @change="changeTime($event)"
        />
        <p class="btns">
          <btn
            class="left"
            :btntext="'重置'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'#fff'"
            :borderradius="'0.4rem'"
            :btncolor="'#333'"
            :fontsize="'1.6rem'"
            :btnborder="'solid 0.05rem #ccc'"
            @btnClick="allTime"
          />
          <btn
            :btntext="selectFirst ? '下一步' : '确定'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'0.4rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            @btnClick="confirm"
          />
        </p>
      </van-popup>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      righticon: require("@/assets/purchaseSupplier/common/search.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      showdate: false,
      selectData: "全部时间",
      startTime: "请选择",
      endTime: "请选择",
      currentDate: new Date(),
      minDate: new Date(2021, 0, 1),
      selectFirst: true,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toSearch() {
      this.$router.push({
        path: "/purchaseSupplier/searchSettled",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    // chageTab(index) {
    //   if (index == 1) {
    //     this.selectFirst = true;
    //   } else {
    //     this.selectFirst = false;
    //   }
    // },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      let parm = { page: this.page, supplier_id: this.$route.query.id };
      if (this.selectData != "全部时间") {
        parm = {
          page: this.page,
          supplier_id: this.$route.query.id,
          start_time: this.startTime,
          end_time: this.endTime,
        };
      }
      this.$api
        .post(
          "/member-relation/member/three/year/supplier/amount-details",
          parm
        )
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    showDatePopup() {
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.selectFirst = true;
      this.currentDate = new Date();
      this.changeTime(this.currentDate);

      this.showdate = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    changeTime(value) {
      var year = this.currentDate.getFullYear();
      var month = this.currentDate.getMonth() + 1;
      var day = this.currentDate.getDate();
      if (this.selectFirst) {
        this.startTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      } else {
        this.endTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      }
    },
    confirm() {
      if (this.selectFirst) {
        this.selectFirst = false;
        this.changeTime(this.currentDate);
        return;
      }
      // if (this.startTime == "请选择") {
      //   this.$toast("请选择开始时间");
      //   return;
      // } else if (this.endTime == "请选择") {
      //   this.$toast("请选择结束时间");
      //   return;
      // }
      this.showdate = false;
      this.selectData =
        this.startTime.replace(/-/g, ".") +
        "-" +
        this.endTime.replace(/-/g, ".");
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    allTime() {
      this.showdate = false;
      this.selectData = "全部时间";
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding-top: 8.8rem;
    box-sizing: border-box;
    height: 100%;

    .search {
      height: 2.1rem;
      line-height: 2.1rem;
      padding: 0 1.6rem;
      color: #2c2c2f;
      font-size: 1.2rem;
      margin-top: 1.1rem;

      span {
        float: left;
        .van-icon {
          margin-left: 0.7rem;
          width: 0.5rem;
          transform: translateY(-3px);
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg);
        }
      }

      .icon {
        margin-top: -0.2rem;
      }
    }

    .van-pull-refresh {
      height: calc(100% - 4.4rem);
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 13.1rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 2rem 1.6rem;
        box-sizing: border-box;

        .van-col {
          color: #999;
          font-size: 1.2rem;
          line-height: 2.5rem;

          .commission {
            float: right;
            color: #333;
            font-size: 1.2rem;
            height: 2.4rem;
            line-height: 2.4rem;

            .word {
              height: 2.4rem;
              line-height: 2.4rem;
              display: inline-block;
              float: left;
            }

            .balance {
              color: #ff4747;
              font-size: 2rem;
              font-weight: 700;

              span {
                margin-right: 1rem;
              }
            }
          }
        }

        .title {
          color: #333;
          font-size: 1.4rem;
          text-align: left;
          line-height: 2rem;
          margin-bottom: 0.4rem;
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }

    .van-popup {
      height: 43rem;

      .title {
        height: 8rem;

        .van-col {
          background: #f8f8f8;
          text-align: center;
          height: 8rem;

          p {
            color: #333;
            font-size: 1.4rem;
            line-height: 1.7rem;
          }

          .decs {
            color: #999;
            font-size: 1.2rem;
            margin: 1.8rem 0 0.6rem;
            line-height: 2rem;
          }
        }

        .active {
          background: #fff;

          span {
            display: block;
            width: 100%;
            height: 0.3rem;
            margin-top: 1.6rem;
            background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(to right, #fc740c, #f41a3c);
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #fc740c, #f41a3c);
          }
        }
      }

      /deep/.van-picker {
        height: 29rem;
        padding: 1.6rem 0;
        box-sizing: border-box;

        .van-picker__toolbar {
          display: none;
        }
      }

      .btns {
        padding-left: 1.6rem;

        .left {
          margin-right: 1.1rem;
        }
      }
    }
  }
}
</style>




